<div class="content">
    <div class="card m-5">

        <div class="card-body">
            <h4 class="card-title">Email Confirmation</h4>
            <form [formGroup]="verifyForm" (ngSubmit)="onSubmit()">
                <small style="font-size: 16px;margin-bottom: 15px;">We've sent a code to your email account. Please
                    enter that code below. </small>
                    <div *ngIf="showErrMsg" class="err-msg"><b>{{errorMessage}}</b></div>
                    <div class="form-group m-3">
                        <input type="number" onwheel="this.blur()" formControlName="verificationCode"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                            maxlength="6" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                            placeholder="000000"  [class.invalid]="(verifyFormControlItem['verificationCode']?.valid || submitted) && verifyFormControlItem['verificationCode'].hasError('required')">
                            <span class="text-danger"
                            *ngIf="(verifyFormControlItem['verificationCode']?.valid || submitted) && verifyFormControlItem['verificationCode'].hasError('required')">
                            Verification code is required
                        </span>
                    </div>

                    <div class="resend-txt" *ngIf="!resend" >
                        <small>Resend Email in 00:{{timer}}</small>
                    </div>

                    <div class="resend-txt" *ngIf="resend" (click)="resendVerficationEmail()">
                        <small>Resend Email</small><br />
                    </div>
                    <!-- <div class="form-group m-3" id="example1">
                        <re-captcha errorMode="handled" siteKey="6Lf9eXEUAAAAAJuTO76-FWbmygxR443PHHFe-YXu"></re-captcha>
                    </div> -->
                <!-- <div class="resend-txt m-2"  *ngIf="resend">
                    <small>Resend Email in 00:32</small>
                </div>
                <div class="resend-txt m-2"  *ngIf="!resend">
                    <small>Resend Email</small><br />
                </div> -->
                <div class="signin-btn">
                    <button type="submit" class="btn btn-primary"
                    appTrackClick 
                    [buttonProps]="{
                        title: 'verify_otp_button',
                        feature_context: 'LOGIN'
                        }"
                    >Verify Email</button>
                </div>
            </form>
        </div>
    </div>
</div>
<ng-template #progressDialog>
    <mat-dialog-content>
        <p style="font-size: 18px;">Logging you in please wait!</p>
    </mat-dialog-content>
    <mat-spinner [diameter]="30" [strokeWidth]="3" mode="indeterminate" style="margin: auto;"></mat-spinner>
    <!-- <mat-dialog-actions align="end">
      <button mat-button matDialogClose color="primary">Dismiss</button>
    </mat-dialog-actions> -->
</ng-template>